import { render } from "./GeneralTemplateView.vue?vue&type=template&id=17a3562c"
import script from "./GeneralTemplateView.vue?vue&type=script&lang=js"
export * from "./GeneralTemplateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__